<div class="auth-wrapper">
  <div class="auth-wrapper__main">
    <sc-auth-page-header
      class="auth-wrapper__main__header"
      [authAction]="authAction"
    ></sc-auth-page-header>
    <div class="auth-wrapper__main__content">
      <div class="auth-wrapper__main__content__header">
        <h1 class="auth-wrapper__main__content__header--title">{{mainTitle}}</h1>
        <h3 class="auth-wrapper__main__content__header--subtitle">
          {{subtitle}}
          <ng-content select="[auth-page-wrapper-subtitle]"></ng-content>
        </h3>
      </div>
      <div class="auth-wrapper__main__content__body">
        <ng-content select="[auth-page-wrapper-content]"></ng-content>
      </div>
    </div>
    <div class="auth-wrapper__main__footer">
      <ng-content select="[auth-page-wrapper-footer]"></ng-content>
    </div>
  </div>
  <div class="auth-wrapper-background" [ngStyle]="{'background-image': backgroundImage}">
    <ng-content select="[auth-page-wrapper-background-content]"></ng-content>
  </div>
  <sc-lateral-menu></sc-lateral-menu>
</div>
